export const SINGLE_PET = 'single'
export const TWO_PETS = 'two'
export const INFINITE_PETS = 'infinite'
